import { memo } from 'react';
import { ProductCard } from '../ui';

const CatalogProductGrid = ({ products, priorityImageCount = 0 }) => (
  <div className="grid grid-cols-2 gap-[12px] md:grid-cols-2 md:gap-[20px] lg:grid-cols-4 lg:gap-[24px]">
    {products.map((product, index) => (
      <ProductCard
        key={product._id || product.id}
        product={product}
        showAdd
        imageLoading={index < priorityImageCount ? 'eager' : 'lazy'}
        imageFetchPriority={index < priorityImageCount ? 'high' : 'auto'}
      />
    ))}
  </div>
);

export default memo(CatalogProductGrid);
